import axios from 'axios'
import type { UserInfo } from '@/types/api'


// 钉钉登录相关 - 使用独立 axios 实例，绕过 baseURL
export function getUserInfo(authCode: string, org: 'primary' | 'backup' = 'primary'): Promise<UserInfo> {
  // 使用完整 URL，不经过 request 封装的 baseURL
  return axios.get('/auth/get_user_info', {
    params: { user_code: authCode, org }
  }).then((response: any) => {
    const data = response.data
    console.log(`[getUserInfo] 后端返回 (org=${org}):`, data)
    if (data && data.person_id) {
      return {
        session_token: data.session_token,  // 重要：保存后端返回的 session_token
        ding: data.ding || {},
        person_id: data.person_id,
        udm_person: data.udm_person || null,
        // 角色信息
        is_super_admin: data.is_super_admin ?? false,
        is_system_admin: data.is_system_admin ?? false,
        is_approval_admin: data.is_approval_admin ?? false,
        // 研发角色
        is_rd: data.is_rd ?? false,
        rd_type: data.rd_type ?? null,
        // 兼容旧字段
        access_user: data.access_user || [],
        access_tel_user: data.access_tel_user || [],
        sel_box: data.sel_box || [],
        sel_box_kv: data.sel_box_kv || []
      }
    }
    return Promise.reject(new Error('获取用户信息失败'))
  })
}

// 钉钉登录 - 返回 JWT token
export function dingtalkLogin(authCode: string, org: 'primary' | 'backup' = 'primary'): Promise<{
  access_token: string
  token_type: string
  user: UserInfo
}> {
  return axios.get('/auth/dingtalk', {
    params: { code: authCode, org }
  }).then((response: any) => {
    const data = response.data
    console.log(`[dingtalkLogin] 后端返回 (org=${org}):`, data)
    if (data && data.access_token) {
      return data
    }
    return Promise.reject(new Error('登录失败'))
  })
}
